/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./TextIcon.vue?vue&type=template&id=350a26d8&scoped=true"
import script from "./TextIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./TextIcon.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TextIcon.vue?vue&type=style&index=0&id=350a26d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350a26d8",
  null
  
)

export default component.exports